import { put, call } from 'redux-saga/effects';

import {
  fetchDashboardIntervalRequest,
  createComponentRequest,
  updateComponentRequest,
  deleteComponentRequest,
} from '../requests';
import {
  createComponent,
  updateComponentReceived,
  updateComponent,
  deleteComponent,
  deleteComponentReceived,
  closeModal,
} from '../../../actions';

export function* fetchDashboardService() {
  yield call(fetchDashboardIntervalRequest);
}

export function* createComponentService(type, data) {
  yield put(createComponent(type, data));

  const { success } = yield call(createComponentRequest, type, data);

  if (success) {
    yield put(closeModal());
  }
}

export function* updateComponentReceivedService(data) {
  yield put(updateComponentReceived(data));
}

export function* updateComponentService(type, id, data) {
  yield put(updateComponent(type, id, data));
  yield call(updateComponentRequest, type, id, data);
}

export function* deleteComponentReceivedService(id) {
  yield put(deleteComponentReceived(id));
}

export function* deleteComponentService(id) {
  yield put(deleteComponent(id));
  yield call(deleteComponentRequest, id);
}
